export default __webpack_public_path__ + "static/bbb-26d165ce61c002ed69b07f69f27b1cae.png";